import {StripePayoutApiDto} from "../../api/model/rest";
import Transaction, {BankAccountType, ReconciliationStatus} from "./Transaction";
import moment = require("moment");

export default class StripePayout {

	constructor(public readonly id: string,
		public readonly stripePayoutId: string,
		public readonly dateTime: moment.Moment,
		public readonly url: string,
		public readonly due: number,
		public readonly fee: number,
		public readonly reconciliationStatus: ReconciliationStatus,
		public readonly bankAccountType: BankAccountType,
		public readonly matched: boolean,
		public readonly transactions: Transaction[]) {}

	static fromJson(json: StripePayoutApiDto): StripePayout {
		const transactions = json.transactions.map(Transaction.fromJson);
		return new StripePayout(json.id, json.stripePayoutId, moment(json.dateTime), json.url, json.due, json.fee,
			ReconciliationStatus[json.status.reconcileStatus], BankAccountType[json.bankAccountType], json.status.matched, transactions);
	}
}
